import mapboxgl from 'mapbox-gl';

// Border-only style for regions with very thin lines
export const createRegionBorderLayer = (): mapboxgl.AnyLayer => {
  return {
    id: 'region-borders',
    type: 'line',
    source: 'regions',
    layout: {},
    paint: {
      'line-color': [
        'match',
        ['get', 'code'],
        'CHIS', '#9333ea', // Purple for Chiapas
        'HGO', '#f97316', // Orange for Hidalgo
        '#d1d5db'        // Default gray for other regions
      ],
      'line-width': [
        'match',
        ['get', 'code'],
        'CHIS', 2, // Thicker for Chiapas
        'HGO', 2,  // Thicker for Hidalgo
        1        // Default thickness
      ],
      'line-opacity': 0.8
    }
  };
};

// Selection style - more visible border
export const createSelectionLayer = (regionId: string): mapboxgl.AnyLayer => {
  return {
    id: 'region-selected',
    type: 'line',
    source: 'regions',
    filter: ['==', 'code', regionId],
    layout: {},
    paint: {
      'line-color': '#94a3b8',  // Darker, more visible color
      'line-width': 2.0,        // Thicker line for better visibility
      'line-opacity': 0.7,      // Higher opacity
      'line-dasharray': [2, 1]
    }
  };
};

// Special region highlight style for Hidalgo - with fill and border combined
export const createHidalgoHighlightLayer = (): mapboxgl.AnyLayer => {
  return {
    id: 'hidalgo-highlight',
    type: 'line',
    source: 'regions',
    filter: ['==', 'code', 'HGO'],
    layout: {
      visibility: 'visible'
    },
    paint: {
      'line-color': '#f97316',    // Orange
      'line-width': 5,            // MUCH thicker border
      'line-opacity': 0.9,        // Higher opacity
      'line-blur': 0.5            // Slight blur for softer look
    }
  };
};

// Special region highlight style for Chiapas - with fill and border combined
export const createChiapasHighlightLayer = (): mapboxgl.AnyLayer => {
  return {
    id: 'chiapas-highlight',
    type: 'line',
    source: 'regions',
    filter: ['==', 'code', 'CHIS'],
    layout: {
      visibility: 'visible'
    },
    paint: {
      'line-color': '#9333ea',    // Purple
      'line-width': 5,            // MUCH thicker border
      'line-opacity': 0.9,        // Higher opacity
      'line-blur': 0.5            // Slight blur for softer look
    }
  };
};
